import React from "react";
import { FaWindowClose } from "react-icons/fa";
import { Card, CardBody } from "reactstrap";

export default function ViewForm({ Modalclose, modalData }) {
  if (!modalData) {
    return null; // or return some default content if modalData is null or undefined
  }

  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container">
        <div className="modal-head">
          <h1>Video DETAILS</h1>
          <div className="close-icon">
            <FaWindowClose onClick={Modalclose} />
          </div>
        </div>
        <div className="modal-body">
          <Card>
            <CardBody>
              <section className="view-blog view-sec">
                <div className="container">
                  <div className="mt-3 view-text">
                    {modalData.title && (
                      <>
                        <label className="heading">Title</label>
                        <p>{modalData.title}</p>
                      </>
                    )}
                    {modalData.name && (
                      <>
                        <label className="heading">Name</label>
                        <p>{modalData.name}</p>
                      </>
                    )}
                    {modalData.shortdescription && (
                      <>
                        <label className="heading">Short Description</label>
                        <p>{modalData.shortdescription}</p>
                      </>
                    )}
                    {modalData.designation && (
                      <>
                        <label className="heading">Designation</label>
                        <p>{modalData.designation}</p>
                      </>
                    )}
                    {modalData.description && (
                      <>
                        <label className="heading">Description</label>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: modalData.description,
                          }}
                        />
                      </>
                    )}
                    {modalData.video_url && (
                      <>
                        <label className="heading">Video URL</label>
                        <p>{modalData.video_url}</p>
                      </>
                    )}
                    {modalData.thumbnail_image && (
                      <>
                        <label className="heading">Video Image</label>
                        <img
                          src={`${modalData.thumbnail_image}?${Date.now()}`}
                          alt="Thumbnail"
                        />
                      </>
                    )}
                    {modalData.video_type_name && (
                      <>
                        <label className="heading">Video Type</label>
                        <p>{modalData.video_type_name}</p>
                      </>
                    )}

                    <label className="heading">Status</label>
                    <div className="status-details">
                      <span
                        className={`status ${
                          modalData.status ? "active" : "inactive"
                        }`}
                      >
                        {modalData.status ? "active" : "inactive"}
                      </span>
                    </div>
                  </div>
                </div>
              </section>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}
